import React from "react";

import Container from "components/Layout/Container";
import Header from "components/Layout/Header";
import PublishButton from "components/PublishButton";

import DefaultQuickLinkDetails from "pages/Content/Resources/QuickLinks/QuickLinkDetails";

class QuickLinkDetails extends React.Component<any> {
  render() {
    return (
      <Container header={<Header controls={<PublishButton />} />}>
        <DefaultQuickLinkDetails />
      </Container>
    );
  }
}

export default QuickLinkDetails;
